import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { GlobalPriceChartRequest } from './global-price-chart-request';

export class GlobalPriceChartResponseModel extends GlobalResponseObject{
    data?: GlobalPriceChartRequest[]

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: GlobalPriceChartRequest[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}
